import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from 'components/Service/headerfooterApi';
import { useLocation } from 'react-router-dom';
import { API_BASE_IMG_URl } from 'helper/environment';
import { HashLink } from "react-router-hash-link";
import { Link } from 'react-router-dom';
/* =======================
   TypeScript Interfaces
======================= */

interface FormattedText {
  value: string;
  format: string;
  processed: string;
  summary?: string;
}

interface FooterColumnLink {
  uri: string;
  title: string;
  options?: any[];
}

interface FooterColumnAttributes {
  field_column_title_link: any;
  field_column_title_formatted?: FormattedText | null;
  field_column_links?: FooterColumnLink[];
}

interface FooterColumn {
  id: string;
  attributes: FooterColumnAttributes;
}

interface SocialLink {
  id: string;
  attributes: {
    field_icon_class: string;
    field_link: {
      uri: string;
      title: string;
    };
  };
}

interface FooterAttributes {
  field_company_name1: string;
  field_tagline1: string;
  field_email1: string;
  field_phone_number: string;
  field_phone_title: string;
  field_cta_title: string;
  field_cta_description: string;
  field_cta_button_text: string;
  field_copyright_text: string;
  field_legal_links?: FooterColumnLink[];
}

/* =======================
   Footer Component
======================= */

const Footer: React.FC = () => {
  const [footer, setFooter] = useState<any | null>(null);
    const [img, setImg] = useState<any>(null);
  const [footerColumns, setFooterColumns] = useState<FooterColumn[]>([]);
  const [socialLinks, setSocialLinks] = useState<SocialLink[]>([]);

  // Hide top footer on specific pages
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();
  const hideTopFooter =
    pathname === '/commercial-offsite' || 
    pathname === '/commercial-onsite' 
  
  
 const hideTopSelect =
    pathname === '/' ;
  const normalizeUrl = (uri: string) =>
    uri.startsWith('internal:') ? uri.replace('internal:', '') : uri;

  useEffect(() => {
    fetch(API_ENDPOINTS.FOOTER)
      .then((res) => res.json())
      .then((json) => {
        setFooter(json.data[0].attributes);
          const included = json.included || [];
          const relationships =json.data[0].relationships;
          const getImageFromMedia = (mediaId?: string) => {
            if (!mediaId) return { url: null, alt: null };
        
            const media = included?.find(
              (inc: any) =>
                (inc.type === "media--image" || inc.type === "media--svg_image") &&
                inc.id === mediaId,
            );
        
            if (!media) return { url: null, alt: null };
        
            // handle both image and svg relationship fields
            const imageField =
              media.relationships?.field_media_image?.data ||
              media.relationships?.field_media_svg_image?.data;
        
            if (!imageField?.id) return { url: null, alt: null };
        
            const file = included?.find(
              (inc: any) => inc.type === "file--file" && inc.id === imageField.id,
            );
        
            const fileUrl = file?.attributes?.uri?.url
              ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
              : null;
        
            const altText = imageField?.meta?.alt || media?.attributes?.name || "";
        
            return {
              url: fileUrl,
              alt: altText,
            };
          };
          const featureImages = relationships.field_footer_image?.data?.id || [];
      
          setImg(getImageFromMedia(featureImages));
        setFooterColumns(
          included.filter(
            (item: any) => item.type === 'paragraph--footercolumn'
          )
        );

        setSocialLinks(
          included.filter(
            (item: any) => item.type === 'paragraph--social_link'
          )
        );
      })
      .catch((err) => console.error('Footer API error', err));
  }, []);

 // console.log(img,footer);
  if (!footer) return null;
const conlist = footer?.field_footer_company_mail_contac.map((item:any, index:any) => ({
  icon: footer?.field_company_mail_conatct_icon[index],
  title: item.title,
  link: item.uri
}));
  return (
    <>
      {/* ================= Footer Top CTA ================= */}
      {hideTopFooter && (
       <div className="footer-top container-fluid bg-dark text-white ">
        <div className="container py-5">
            <div className="row gx-2">
                <div className="col-md-6 col-sm-12">
                    <div className="d-lg-flex d-sm-block text-sm-center text-md-start   mb-md-1 mb-4">
                        <i className="fa fa-envelope fa-3x  pe-md-4  mb-3 mb-md-3 md-lg-0"></i>
                        <div className="">
                           <div className="" dangerouslySetInnerHTML={{  __html: footer?.field_footer_mail_description?.value || "" }} />
                            <a href={normalizeUrl(footer?.field_footer_button_enquiry?.uri)} className="btn btn-sm btn-light rounded-pill">{footer?.field_footer_button_enquiry?.title}</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12">
                    <div className="d-lg-flex d-sm-block text-sm-center text-md-start  justify-content-end align-items-start">
                        <i className="fa fa-phone fa-2x pe-md-4 mt-2 mb-3 mb-md-3 md-lg-0"></i>
                        <div>
                           <div className="text-white" dangerouslySetInnerHTML={{  __html: footer?.field_footer_contact_description?.value || "" }} />
                            <div className="d-lg-flex">
                                {footer.field_footer_contact_info_first.map((f : any, i : any) => (
                          
                                <p key={i} className={`${i % 2 === 0 ? '' : 'ps-lg-3 ps-sm-0'}`} dangerouslySetInnerHTML={{  __html: f?.value || "" }} />
                                   
                                ))}
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       </div>
      )}

      {/* ================= Footer Main ================= */}
      

      <div className="container-fluid bg-dark text-white footer  ">
        <div className="container py-5">
            <div className="row g-5 ">
                <div className="col-lg-3 col-md-6 col-sm-12 footer-col">
                    <h5 className="text-white mb-3"> {footer?.field_footer_company_name}</h5>
                     {conlist && conlist.map((f : any, i : any) => (
                    <p className="mb-2" key={i}>
                      <a href={f?.link}>
                          <i className={`${f?.icon} me-3`}></i>
                          {f.title}
                        </a>

                    </p>
                     ))}
                  
                    <div className="d-flex pt-2">
                       {socialLinks.map((item) => (
                        <a
                          key={item.id}
                          href={normalizeUrl(item.attributes.field_link.uri)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-square btn-outline-light btn-social"
                        >
                          <i className={item.attributes.field_icon_class}></i>
                        </a>
                      ))}
                       
                    </div>
                </div>
                <div className="col-lg-9 col-md-6  col-sm-12 d-xl-block d-lg-block d-none">
                    <div className=" d-sm-block d-md-block d-lg-block justify-content-between">
                        <div className="row gx-2">
                           {footerColumns.map((col) => (
                          <div key={col.id} className="footer-link footer-link col-sm-2 mb-4">
                            <h6 className="text-white mb-4">
                            <Link to={normalizeUrl(col.attributes.field_column_title_link.uri)}>
                               {col.attributes.field_column_title_link.title}
                             </Link>
                            </h6>

                            {col.attributes.field_column_links?.map((link, index) => (
                              // <a
                              //   key={index}
                              //   href={normalizeUrl(link.uri)}
                              //   className="btn btn-link"
                              // >
                                
                              // </a>
                              <HashLink smooth to={normalizeUrl(link.uri)}  key={index} className="btn btn-link">
                                {link.title}
                                </HashLink>
                            ))}
                          </div>
                        ))}
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
         <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
               &copy; {new Date().getFullYear()} {footer.field_copyright_text}
              </div>
              <div className="col-md-6 text-center text-md-end d-none">
                {footer.field_legal_links?.map((link:any, i:any) => (
                  <a
                    key={i}
                    href={normalizeUrl(link.uri)}
                    className="text-white ms-3"
                  >
                    {link.title}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
    </div>
      {/* {hideTopSelect && (
     <div id="selector">
        <div id="demo-rtl" className="sc-opt bg-white">
            <div className="sc-icon"><img src="assets/img/calc-icon.png" className="img-fluid" /></div><span className="sc-val  py-2 text-primary">Calculator</span>
        </div>
        <div className="sc-opt sc-mt bg-white">
            <div className="sc-icon"><img src="assets/img/chat-icon.png" className="img-fluid" /></div><span className="sc-val text-black py-2"><a href="contact-us">Get In Touch</a></span>
           
        </div>
      </div>
      )} */}
          {/* <!-- Footer End --> */}
    <div className="footer-bottom p-2">
        <img src={img?.url} alt={img?.alt} width="190" />
    </div>
    {/* <!-- Back to Top --> */}
    </>
  );
};

export default Footer;
